(function($) {
    $(window).on('load', function () {
        var hash = location.hash.substr(1);

        if (hash !== 'ot-show-settings') {
            return;
        }

        var checkExist = setInterval(function() {
            if (typeof OneTrust !== 'undefined' && typeof OneTrust.ToggleInfoDisplay === 'function' && document.getElementById('onetrust-style')) {
                OneTrust.ToggleInfoDisplay();
                clearInterval(checkExist);
            }
        }, 200);
    });

}(jQuery));